<template><section><template>
<h3>评分</h3>
<div class="bs-docs-section">
<div class="bs-example">
<n3-rate v-model="value"></n3-rate>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-rate</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-rate</span>&gt;</span>
</code></pre>
<p><n3-rate v-model="value1" allow-half=""></n3-rate></p>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-rate</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value1"</span> <span class="hljs-attr">allow-half</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-rate</span>&gt;</span>
</code></pre>
<p><n3-rate v-model="value2" show-text="" :colors="['#ffeb3b','#ff9800','#f44336']"></n3-rate></p>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-rate</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value2"</span> <span class="hljs-attr">show-text</span> <span class="hljs-attr">:colors</span>=<span class="hljs-string">"['#ffeb3b','#ff9800','#f44336']"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-rate</span>&gt;</span>
</code></pre>
</div>
<h3>参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>max</td>
<td><code v-pre="">Number</code></td>
<td><code v-pre="">5</code></td>
<td>最大个数</td>
</tr>
<tr>
<td>allow-half</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>是否支持半数</td>
</tr>
<tr>
<td>colors</td>
<td><code v-pre="">Array</code></td>
<td><code v-pre="">['#F7BA2A', '#F7BA2A', '#F7BA2A']</code></td>
<td>颜色</td>
</tr>
<tr>
<td>voidColor</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">#C6D1DE</code></td>
<td>未选中颜色</td>
</tr>
<tr>
<td>disabledVoidColor</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">#EFF2F7</code></td>
<td>禁止情况下为选中颜色</td>
</tr>
<tr>
<td>disabled</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>禁止操作</td>
</tr>
<tr>
<td>disabled-void-icon</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">star</code></td>
<td>禁止操作的图标</td>
</tr>
<tr>
<td>void-icon</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">star-o</code></td>
<td>未选中图标</td>
</tr>
<tr>
<td>icons</td>
<td><code v-pre="">Array</code></td>
<td><code v-pre="">['star', 'star', 'star']</code></td>
<td>选中图标</td>
</tr>
<tr>
<td>show-text</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>是否显示文本解释</td>
</tr>
<tr>
<td>text-color</td>
<td><code v-pre="">string</code></td>
<td><code v-pre="">#1f2d3d</code></td>
<td>文本颜色</td>
</tr>
<tr>
<td>texts</td>
<td><code v-pre="">Array</code></td>
<td><code v-pre="">[]</code></td>
<td>文本</td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>
  export default {
    data () {
      return {
        value: 3,
        value1: 2.5,
        value2: 4
      }
    },
    mounted() {
      this.value =1
    }
  }
</script>


// WEBPACK FOOTER //
// n3RateDocs.md?7275e3a5